import React from "react";
import { ChevronRight } from "lucide-react";

const ITEMS = [
  { name: "Booking platform", status: "in build", tone: "cyan" },
  { name: "Member portal", status: "launched", tone: "green" },
  { name: "AI assistant suite", status: "prototyping", tone: "amber" },
  { name: "Operator dashboard", status: "in build", tone: "cyan" },
  { name: "Hospitality CRM", status: "scoping", tone: "slate" },
  { name: "Service marketplace", status: "concept", tone: "slate" },
  { name: "Accountancy portal", status: "launched", tone: "green" },
  { name: "Fitness companion app", status: "live", tone: "cyan", pulse: true },
];

const TONE_CLASSES = {
  cyan: { dot: "bg-[#00D4FF]", text: "text-[#7DD3FC]" },
  green: { dot: "bg-emerald-400", text: "text-emerald-300" },
  amber: { dot: "bg-amber-400", text: "text-amber-300" },
  slate: { dot: "bg-slate-500", text: "text-slate-400" },
};

export default function StudioTicker() {
  // Duplicate the array so the marquee loops seamlessly
  const track = [...ITEMS, ...ITEMS];

  return (
    <section
      data-testid="studio-ticker-section"
      className="relative border-b border-white/[0.06] bg-[#06101D]/30 py-5 md:py-6 overflow-hidden"
      aria-label="Currently in the studio"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="flex items-center gap-5 md:gap-7">
          <div className="shrink-0 inline-flex items-center gap-2.5">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full rounded-full bg-[#00D4FF] opacity-60 animate-ping" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-[#00D4FF]" />
            </span>
            <span className="text-[10.5px] uppercase tracking-[0.24em] text-slate-400 font-medium whitespace-nowrap">
              In the studio
            </span>
          </div>

          <div className="relative flex-1 min-w-0 mk-marquee">
            <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-[#07111F] via-[#07111F]/90 to-transparent z-10" aria-hidden />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-[#07111F] via-[#07111F]/90 to-transparent z-10" aria-hidden />

            <div className="mk-marquee-track flex items-center gap-10" aria-hidden>
              {track.map((item, i) => {
                const tone = TONE_CLASSES[item.tone] || TONE_CLASSES.slate;
                return (
                  <div
                    key={`${item.name}-${i}`}
                    data-testid={i < ITEMS.length ? `ticker-item-${i}` : undefined}
                    className="inline-flex items-center gap-3 shrink-0"
                  >
                    <ChevronRight className="h-3 w-3 text-slate-600" />
                    <span className="text-[13px] text-slate-200 font-medium whitespace-nowrap tracking-tight">
                      {item.name}
                    </span>
                    <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                      <span
                        className={`h-1.5 w-1.5 rounded-full ${tone.dot} ${item.pulse ? "mk-pulse" : ""}`}
                      />
                      <span className={`text-[12px] ${tone.text}`}>{item.status}</span>
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
